/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import Header from "./Header";
import axiosInstance from "../../axios/axios";
import { FaArrowLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const AdminOrgDetails = () => {
  const navigate = useNavigate();
  const [orgDetails, setOrgDetails] = useState({});
  const id = window.location.pathname.split("/").pop();
  const [loading, setLoading] = useState(true);

  const [jobsPage, setJobsPage] = useState(1);
  const [applicationsPage, setApplicationsPage] = useState(1);
  const [interviewsPage, setInterviewsPage] = useState(1);
  const [itemsPerPage] = useState(5);

  useEffect(() => {
    const fetchAdminJobs = async () => {
      try {
        const res = await axiosInstance.get(`organization/${id}/details`);
        const foundOrgs = res.data.organization;
        setOrgDetails(foundOrgs);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminJobs();
  }, [id]);

  const handleVerification = async (action) => {
    try {
      const endpoint =
        action === "accept"
          ? `verify-organization/${id}`
          : `reject-organization/${id}`;

      await axiosInstance.put(endpoint);
      window.location.reload();
    } catch (error) {
      console.error(`Error ${action}ing organization:`, error);
      alert(`Failed to ${action} organization. Please try again.`);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Pagination functions for Jobs
  const jobsIndexLast = jobsPage * itemsPerPage;
  const jobsIndexFirst = jobsIndexLast - itemsPerPage;
  const currentJobs =
    orgDetails.jobs?.slice(jobsIndexFirst, jobsIndexLast) || [];
  const jobsTotalPages = Math.ceil(
    (orgDetails.jobs?.length || 0) / itemsPerPage
  );

  // Pagination functions for Applications
  const applicationsIndexLast = applicationsPage * itemsPerPage;
  const applicationsIndexFirst = applicationsIndexLast - itemsPerPage;
  const currentApplications =
    orgDetails.applications?.slice(
      applicationsIndexFirst,
      applicationsIndexLast
    ) || [];
  const applicationsTotalPages = Math.ceil(
    (orgDetails.applications?.length || 0) / itemsPerPage
  );

  // Pagination functions for Interviews
  const interviewsIndexLast = interviewsPage * itemsPerPage;
  const interviewsIndexFirst = interviewsIndexLast - itemsPerPage;
  const currentInterviews =
    orgDetails.interviews?.slice(interviewsIndexFirst, interviewsIndexLast) ||
    [];
  const interviewsTotalPages = Math.ceil(
    (orgDetails.interviews?.length || 0) / itemsPerPage
  );

  const Pagination = ({ currentPage, totalPages, paginate }) => {
    // Don't show pagination if there's only 1 page
    if (totalPages <= 1) return null;

    const pageNumbers = [];
    const maxPageNumbers = 5; // Increased to show more page numbers

    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2));
    let endPage = Math.min(totalPages, startPage + maxPageNumbers - 1);

    if (endPage - startPage + 1 < maxPageNumbers) {
      startPage = Math.max(1, endPage - maxPageNumbers + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <div className="flex justify-center items-center mt-4">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className={`mx-1 px-3 py-1 rounded ${
            currentPage === 1
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          <FaChevronLeft size={14} />
        </button>

        {startPage > 1 && (
          <>
            <button
              onClick={() => paginate(1)}
              className="mx-1 px-3 py-1 rounded bg-gray-200 text-gray-700 hover:bg-gray-300"
            >
              1
            </button>
            {startPage > 2 && <span className="mx-1">...</span>}
          </>
        )}

        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`mx-1 px-3 py-1 rounded ${
              currentPage === number
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            {number}
          </button>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="mx-1">...</span>}
            <button
              onClick={() => paginate(totalPages)}
              className="mx-1 px-3 py-1 rounded bg-gray-200 text-gray-700 hover:bg-gray-300"
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`mx-1 px-3 py-1 rounded ${
            currentPage === totalPages
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          <FaChevronRight size={14} />
        </button>
      </div>
    );
  };

  return (
    <div>
      <Header />
      <div className="my-6 container-md mx-auto px-4">
        <div className="flex justify-between items-center mb-6">
          <h1 className="font-bold text-2xl underline">Organisation Details</h1>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-blue-600 hover:text-blue-800"
          >
            <FaArrowLeft size={20} className="mr-2" /> Back
          </button>
        </div>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="text-lg">Loading organization details...</div>
          </div>
        ) : (
          <>
            <div className="border-b border-gray-200 pb-4 mb-6">
              <h2 className="text-xl font-semibold text-gray-800">
                {orgDetails.company_name}
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div className="bg-white p-4 rounded-lg shadow">
                <h3 className="font-semibold text-lg mb-2 underline">
                  Company Information
                </h3>
                <div className="space-y-2">
                  <p>
                    <strong>Company's Name: </strong> {orgDetails.company_name}
                  </p>
                  <p>
                    <strong>Company's CAC:</strong>{" "}
                    {orgDetails.company_cac_number || "Not provided"}
                  </p>
                  <p>
                    <strong>Date created:</strong>{" "}
                    {formatDate(orgDetails.created_at)}
                  </p>
                  <p>
                    <strong>Verification Status:</strong>{" "}
                    <span
                      className={
                        orgDetails.verified
                          ? "text-green-600 font-medium"
                          : "text-red-600 font-medium"
                      }
                    >
                      {orgDetails.verified ? "Verified" : "Not Verified"}
                    </span>
                  </p>
                  {!orgDetails.verified && (
                    <div className="flex gap-4 mt-3">
                      <button
                        onClick={() => handleVerification("accept")}
                        className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
                      >
                        Accept
                      </button>
                      <button
                        onClick={() => handleVerification("reject")}
                        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
                      >
                        Reject
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <h3 className="font-semibold text-lg mb-2 underline">
                  Contact Information
                </h3>
                <div className="space-y-2">
                  <p>
                    <strong>Company's State:</strong>{" "}
                    {orgDetails.company_state || "Not provided"}
                  </p>
                  <p>
                    <strong>Company's Address:</strong>{" "}
                    {orgDetails.company_street_address || "Not provided"}
                  </p>
                  <p>
                    <strong>Company's Phone number: </strong>
                    {orgDetails.phone || "Not provided"}
                  </p>
                  <p>
                    <strong>Company's Email Address: </strong>
                    {orgDetails.user?.email || "Not provided"}
                  </p>
                </div>
              </div>
            </div>

            {/* Jobs Section */}
            <div className="bg-white p-4 rounded-lg shadow mb-6">
              <h3 className="font-semibold text-lg mb-4 underline">Jobs</h3>
              {orgDetails.jobs?.length === 0 ? (
                <p className="text-gray-500 py-4 text-center">No Jobs found</p>
              ) : (
                <div className="overflow-auto">
                  <table className="min-w-full border-collapse">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="px-4 py-2 text-left border">S/N</th>
                        <th className="px-4 py-2 text-left border">Title</th>
                        <th className="px-4 py-2 text-left border">
                          Department
                        </th>
                        <th className="px-4 py-2 text-left border">
                          Work mode
                        </th>
                        <th className="px-4 py-2 text-left border">Amount</th>
                        <th className="px-4 py-2 text-left border">Duration</th>
                        <th className="px-4 py-2 text-left border">Deadline</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentJobs.map((each, index) => (
                        <tr key={each.id} className="hover:bg-gray-50">
                          <td className="px-4 py-2 border">
                            {(jobsPage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td className="px-4 py-2 border">{each.job_title}</td>
                          <td className="px-4 py-2 border">
                            {each.department}
                          </td>
                          <td className="px-4 py-2 border">{each.env_mode}</td>
                          <td className="px-4 py-2 border">{each.amount}</td>
                          <td className="px-4 py-2 border">{each.duration}</td>
                          <td className="px-4 py-2 border">{each.deadline}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={jobsPage}
                    totalPages={jobsTotalPages}
                    paginate={setJobsPage}
                  />
                </div>
              )}
            </div>

            {/* Applications Section */}
            <div className="bg-white p-4 rounded-lg shadow mb-6">
              <h3 className="font-semibold text-lg mb-4 underline">
                Applications
              </h3>
              {orgDetails.applications?.length === 0 ? (
                <p className="text-gray-500 py-4 text-center">
                  No Applications found
                </p>
              ) : (
                <div className="overflow-auto">
                  <table className="min-w-full border-collapse">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="px-4 py-2 text-left border">S/N</th>
                        <th className="px-4 py-2 text-left border">Name</th>
                        <th className="px-4 py-2 text-left border">
                          Job Title
                        </th>
                        <th className="px-4 py-2 text-left border">Date</th>
                        <th className="px-4 py-2 text-left border">Phone</th>
                        <th className="px-4 py-2 text-left border">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentApplications.map((each, index) => (
                        <tr key={each.id} className="hover:bg-gray-50">
                          <td className="px-4 py-2 border">
                            {(applicationsPage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td className="px-4 py-2 border">
                            {each.student_name || "N/A"}
                          </td>
                          <td className="px-4 py-2 border">
                            {each.job_title || "N/A"}
                          </td>
                          <td className="px-4 py-2 border">
                            {formatDate(each.created_at)}
                          </td>
                          <td className="px-4 py-2 border">
                            {each.student_phone || "N/A"}
                          </td>
                          <td className="px-4 py-2 border">
                            <span
                              className={`px-2 py-1 rounded-full text-xs ${
                                each.status === "Accepted"
                                  ? "bg-green-100 text-green-800"
                                  : each.status === "Rejected"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-blue-100 text-blue-800"
                              }`}
                            >
                              {each.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={applicationsPage}
                    totalPages={applicationsTotalPages}
                    paginate={setApplicationsPage}
                  />
                </div>
              )}
            </div>

            {/* Interviews Section */}
            <div className="bg-white p-4 rounded-lg shadow mb-6">
              <h3 className="font-semibold text-lg mb-4 underline">
                Interviews
              </h3>
              {orgDetails.interviews?.length === 0 ? (
                <p className="text-gray-500 py-4 text-center">
                  No Interviews found
                </p>
              ) : (
                <div className="overflow-auto">
                  <table className="min-w-full border-collapse">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="px-4 py-2 text-left border">S/N</th>
                        <th className="px-4 py-2 text-left border">Name</th>
                        <th className="px-4 py-2 text-left border">Phone</th>
                        <th className="px-4 py-2 text-left border">Email</th>
                        <th className="px-4 py-2 text-left border">Date</th>
                        <th className="px-4 py-2 text-left border">Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentInterviews.map((each, index) => (
                        <tr key={each.id} className="hover:bg-gray-50">
                          <td className="px-4 py-2 border">
                            {(interviewsPage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td className="px-4 py-2 border">
                            {each.student_name || "N/A"}
                          </td>
                          <td className="px-4 py-2 border">
                            {each.student_phone || "N/A"}
                          </td>
                          <td className="px-4 py-2 border break-words">
                            {each.student_email || "N/A"}
                          </td>
                          <td className="px-4 py-2 border">
                            {each.date || "N/A"}
                          </td>
                          <td className="px-4 py-2 border">
                            {each.meet_link ? (
                              <a
                                href={each.meet_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-800 break-words"
                              >
                                Join Meeting
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={interviewsPage}
                    totalPages={interviewsTotalPages}
                    paginate={setInterviewsPage}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminOrgDetails;
